import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace CountryInDataRoomFields {
  export enum ModuleField {
    EnableAutogeneratedFolders = 'CountryInDataRoom.EnableAutogeneratedFolders',
    DefaultReaderGroups = 'CountryInDataRoom.DefaultReaderGroups',
    DefaultEditorsGroups = 'CountryInDataRoom.DefaultEditorsGroups',
    DefaultApproversGroups = 'CountryInDataRoom.DefaultApproversGroups',
    RootFolderName = 'CountryInDataRoom.RootFolderName',
    SortOrder = 'CountryInDataRoom.SortOrder',
    DisabledCountryStatusTypes = 'CountryInDataRoom.DisabledCountryStatusTypes',
    NoDocumentsForActivatedCountries = 'CountryInDataRoom.NoDocumentsForActivatedCountries',
    RMSStatus = 'CountryInDataRoom.RMS.Status',
    RMSISO2 = 'CountryInDataRoom.RMS.ISO2',
    EnableCountryWorkflow = 'CountryInDataRoom.EnableCountryWorkflow',
  }
}

class ModuleConfig extends SettingsSubModule {
  @SettingsSubModule.value(CountryInDataRoomFields.ModuleField.EnableAutogeneratedFolders, false)
  enableAutogeneratedFolders: SettingValue<boolean>;
  @SettingsSubModule.value(CountryInDataRoomFields.ModuleField.DefaultReaderGroups, '')
  defaultReaderGroups: SettingValue<string>;
  @SettingsSubModule.value(CountryInDataRoomFields.ModuleField.DefaultEditorsGroups, '')
  defaultEditorsGroups: SettingValue<string>;
  @SettingsSubModule.value(CountryInDataRoomFields.ModuleField.DefaultApproversGroups, '')
  defaultApproversGroups: SettingValue<string>;
  @SettingsSubModule.value(CountryInDataRoomFields.ModuleField.RootFolderName, 'Country Management')
  rootFolderName: SettingValue<string>;
  @SettingsSubModule.value(CountryInDataRoomFields.ModuleField.SortOrder, 3)
  sortOrder: SettingValue<number>;
  @SettingsSubModule.value(CountryInDataRoomFields.ModuleField.DisabledCountryStatusTypes, '')
  disabledCountryStatusTypes: SettingValue<string>;
  @SettingsSubModule.value(CountryInDataRoomFields.ModuleField.NoDocumentsForActivatedCountries, false)
  noDocumentsForActivatedCountries: SettingValue<boolean>;
  @SettingsSubModule.value(CountryInDataRoomFields.ModuleField.RMSStatus, '')
  RMSStatus: SettingValue<string>;
  @SettingsSubModule.value(CountryInDataRoomFields.ModuleField.RMSISO2, '')
  RMSISO2: SettingValue<string>;
  @SettingsSubModule.value(CountryInDataRoomFields.ModuleField.EnableCountryWorkflow, false)
  EnableCountryWorkflow: SettingValue<boolean>;
}

export class CountryInDataRoomModule extends SettingsModule {
  @SettingsModule.value(ModuleConfig) common: ModuleConfig;
}
